import { MeshPhysicalNodeMaterial } from 'three/webgpu'
import { agxToneMapping, uniform, vec4 } from 'three/tsl'

export default class AgxPhysicalMaterial extends MeshPhysicalNodeMaterial {
	static defaults = { exposure: 1 }

	static adopt(material, options = {}) {
		if (material.toneMappingExposure) return material

		const { exposure } = { ...AgxPhysicalMaterial.defaults, ...options }

		material.toneMappingExposure = uniform(exposure)
		material.setupOutput = AgxPhysicalMaterial.prototype.setupOutput
		material.needsUpdate = true

		return material
	}

	constructor(options = {}) {
		const { exposure, ...rest } = { ...AgxPhysicalMaterial.defaults, ...options }

		super(rest)
		this.toneMappingExposure = uniform(exposure)
	}

	setupOutput(builder, outputNode) {
		const mapped = agxToneMapping(outputNode.rgb, this.toneMappingExposure)

		return super.setupOutput(builder, vec4(mapped, outputNode.a))
	}
}
